/* Absolvire.shop — ETAPA 5K dual theme (light/dark) toggle
 * No dependencies. Preference stored in localStorage under "absolvire-theme".
 * The tiny inline bootstrap script in layout/theme.liquid sets data-theme
 * before first paint; this file wires up the toggle button(s) and keeps
 * everything in sync afterwards.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'absolvire-theme';

  function getStoredTheme() {
    try {
      var t = window.localStorage.getItem(STORAGE_KEY);
      return t === 'light' || t === 'dark' ? t : null;
    } catch (e) {
      return null;
    }
  }

  function storeTheme(theme) {
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
      /* localStorage unavailable (private mode, blocked) — theme still works for this page view */
    }
  }

  function getPreferredTheme() {
    var stored = getStoredTheme();
    if (stored) return stored;
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }
    return 'light';
  }

  function syncThemeButtons(theme) {
    var isDark = theme === 'dark';
    var buttons = document.querySelectorAll('[data-theme-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');
      var label = isDark
        ? btn.getAttribute('data-label-light') || 'Activează modul luminos'
        : btn.getAttribute('data-label-dark') || 'Activează modul întunecat';
      btn.setAttribute('aria-label', label);
    }
  }

  function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    syncThemeButtons(theme);
  }

  function toggleTheme() {
    var current = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    var next = current === 'dark' ? 'light' : 'dark';
    storeTheme(next);
    applyTheme(next);
  }

  function onDocumentClick(event) {
    var target = event.target;
    var btn = target && target.closest ? target.closest('[data-theme-toggle]') : null;
    if (!btn) return;
    event.preventDefault();
    toggleTheme();
  }

  function watchSystemPreference() {
    if (!window.matchMedia) return;
    var mq = window.matchMedia('(prefers-color-scheme: dark)');
    var onChange = function (e) {
      /* Manual choice always wins — only follow the OS when the visitor never toggled manually */
      if (getStoredTheme()) return;
      applyTheme(e.matches ? 'dark' : 'light');
    };
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }

  function init() {
    applyTheme(getPreferredTheme());
    document.addEventListener('click', onDocumentClick);
    watchSystemPreference();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.AbsolvireTheme = {
    getStoredTheme: getStoredTheme,
    getPreferredTheme: getPreferredTheme,
    applyTheme: applyTheme,
    toggleTheme: toggleTheme,
    syncThemeButtons: syncThemeButtons
  };
})();
